var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", [
      _c("iframe", {
        staticClass: "youtube-player",
        attrs: {
          id: "youtube-player-" + _vm._uid,
          src:
            "https://www.youtube-nocookie.com/embed/" +
            _vm.trailers[0].videoId +
            "?rel=0&enablejsapi=1&modestbranding=1&playsinline=1",
          title: "YouTube video player",
          allow:
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
          referrerpolicy: "strict-origin-when-cross-origin",
          allowfullscreen: ""
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "youtube-trailer-buttons" },
      _vm._l(_vm.trailers, function(trailer, idx) {
        return _c(
          "button",
          {
            key: idx,
            class: { active: _vm.activeIndex === idx },
            attrs: { "data-trailer-tab-button": "" },
            on: {
              click: function($event) {
                return _vm.updateYoutubeEmbed(trailer.videoId, idx)
              }
            }
          },
          [_vm._v("\n      " + _vm._s(trailer.label) + "\n    ")]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }